<div class="container d-none d-lg-block py-3">
  <div class="rewards-back-button bg-glass-dark cursor-pointer" (click)="location.back()">
    <span class="material-icons align-middle text-white">arrow_back_ios_new</span>
  </div>
</div>

<!--Point Summary Bar-->
<fgb-points-summary-bar [backButtonLink]="'/rewards/raffles'" [backButtonTitle]="'Raffles'"></fgb-points-summary-bar>

<!--Lotto Details-->
<fgbcl-lotto-details-v2 [lottoId]="id" />
